import styled, { css } from 'styled-components';
import { transparentize } from 'utils/color';
import { secondaryFont } from 'components/mixins/typography';
import { centerAbsoluteElement } from 'components/mixins/placement';

type CourseProgressProps = {
  isPassed: boolean;
};

type CourseProgressCircleProps = {
  progress: number;
  isPassed: boolean;
};

const circleSize = '94px';
const iconSize = '12px';

export const CourseProgress = styled.div<CourseProgressProps>`
  width: ${circleSize};
  height: ${circleSize};
  margin: 0 auto 30px;
  position: relative;

  &:before {
    content: '';
    display: block;
    width: 1px;
    height: 4px;
    background: ${props => props.theme.colors.textColor};
    position: absolute;
    top: -1px;
    left: 50%;
  }
`;

export const CourseProgressText = styled.div<CourseProgressProps>`
  ${secondaryFont};
  position: absolute;
  ${centerAbsoluteElement};
  font-size: 24px;
  color: ${props => transparentize(props.theme.colors.textColor, 0.5)};

  span {
    font-size: 14px;
  }

  ${props =>
    props.isPassed &&
    css`
      color: ${props.theme.colors.correctColor};
    `};
`;

export const CourseProgressCircle = styled.div<CourseProgressCircleProps>`
  position: absolute;
  top: 0;
  left: 0;
  width: ${circleSize};
  height: ${circleSize};

  border-radius: 50%;
  padding: 0;
  list-style: none;
  border: none;

  > * {
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: calc(-${iconSize} / 2);
    margin-left: calc(-${iconSize} / 2);
    width: ${iconSize};
    height: ${iconSize};
    transform: rotate(${props => props.progress}deg) translate(0, calc(-${circleSize} / 2))
      rotate(calc(${props => -props.progress}deg));
  }

  span {
    display: block;
    height: ${iconSize};
    max-width: 100%;
    border-radius: 50%;
    transition: 0.2s;
    background: ${props =>
      props.isPassed
        ? props.theme.colors.correctColor
        : transparentize(props.theme.colors.textColor, 0.5)};
    padding-top: 3px;
  }
`;
